module.exports = __webpack_public_path__ + "static/media/Industriekessel_05.021cd4a2.jpg";